import goodInOutRecord from '@/pages/accessManage/goodInOutRecord.vue';
import visitRecord from '@/pages/accessManage/visitRecord.vue';
export default {
    menuName: '出入管理',
    path: '/crgl',
    children: [{
        path: 'lfry',
        menuName: '来访人员管理',
        component: visitRecord
    }, {
            path: 'wpcr',
            menuName: '物品出入管理',
            component: goodInOutRecord
    }],
    component: (resolve) => require(['@/pages/accessManage/index.vue'], resolve)
}


// WEBPACK FOOTER //
// ./src/routes/modules/accessManage.js